/* eslint-disable camelcase */
import { FC } from 'react';
import { FormattedMessage, MessageDescriptor, useIntl } from 'react-intl';
import en_US from './en-US';
import es_ES from './es-ES';
import pt_BR from './pt-BR';

export const localeConfig = {
  pt_BR,
  en_US,
  es_ES,
};

export type IdLocale = keyof typeof en_US;

interface Props extends MessageDescriptor {
  id: any;
}

export const LocaleFormatter: FC<Props> = ({ ...props }) => {
  const notChildProps = { ...props, children: undefined };
  return <FormattedMessage {...notChildProps} id={props.id} />;
};

type FormatMessageProps = (descriptor: Props, values?: any, opts?: any) => string;

export const useLocale = () => {
  const { formatMessage: _formatMessage, ...rest } = useIntl();
  const formatMessage: FormatMessageProps = _formatMessage;
  return {
    ...rest,
    formatMessage,
  };
};
